module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/store_images/5_db0a3eca3edbf16f4f0da54ae787eeb2.png";